import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CitySelectionSection from "./components/CitySelectionSection";
import StorytellingSection from "./components/StorytellingSection";
import ServicePreviewSection from "./components/ServicePreviewSection";

export default function Home() {
  return (
    <div className="bg-[#F7F6F3]">
      <Navbar />
      <main>
        <HeroSection />
        <CitySelectionSection />
        <StorytellingSection />
        <ServicePreviewSection />
      </main>
      <Footer />
    </div>
  );
}
